import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  const regexAlphaNumeric =
  '^[a-zA-Z0-9]+$'
  const errMsgAlphaNumeric =
  'Only Alpha Numeric Values are allowed'
  const regexAlphaNumericSpace =
  '^[a-zA-Z0-9 ]+$'
  const errMsgAlphaNumericSPace=
  'Only Alpha Numeric with Space is allowed'
  
  return Yup.object({
    scac: Yup.string().required(requiredMessage).nullable().max(4,"Max allowed length is 04.").matches(regexAlphaNumeric,errMsgAlphaNumeric),
    vesselName: Yup.string().required(requiredMessage).nullable().max(23,"Max allowed length is 23.").matches(regexAlphaNumericSpace,errMsgAlphaNumericSPace),
    voyageNumber: Yup.string().required(requiredMessage).nullable().max(5,"Max allowed length is 5.").matches(regexAlphaNumeric,errMsgAlphaNumeric),
    country: Yup.string().nullable().required(requiredMessage),
    portOfDischarge: Yup.string().nullable().required(requiredMessage),
    eta: Yup.date().validFormat().typeError(dateTypeErrorMessage).required(requiredMessage).nullable(),
    modeOfTransport: Yup.string().nullable().required(requiredMessage),
    paperlessInBondParticipant: Yup.string().nullable().required(requiredMessage),
    issuerScac: Yup.string().required(requiredMessage).nullable().max(4,"Max allowed length is 04.").matches(regexAlphaNumeric,errMsgAlphaNumeric),
    billOfLading: Yup.array(),
  })
}

export default makeValidationSchema
